<template>
  <expandable-container :height="'1rem'">
    <span style="line-break: normal" v-html="value"></span>
  </expandable-container>
</template>

<script>
import ExpandableContainer from '@kanrisha/components/Elements/Container/ExpandableContainer';

export default {
  components: {
    ExpandableContainer,
  },
  props: {
    value: { type: String, default: '' },
  },
  setup() {
    return {};
  },
};
</script>
